<template>
    <div style="padding-top:30px;">
        <div class="page-titles p-3 border-bottom">
            <h3 class="text-themecolor">{{trans('user.user')}} 
                <span class="card-subtitle" v-if="user.profile">{{user.profile.first_name+' '+user.profile.last_name}} ({{user.email}})</span>
              <button class="btn btn-info btn-sm pull-right" @click="$router.push('/account/users/general-partners')"><i class="fas fa-list"></i> <span class="d-none d-sm-inline">General Partners</span></button>
            </h3>
        </div>
        <div class="container-fluid p-0 pta-documents-premium" style="font-size: 0.75em;">
            <div class="row">
                <div class="col-12 col-sm-8">
                    <div class="card">
                        <div class="card-body p-4">
                            <div class="row">
                                <user-sidebar menu="documents" :id="id"></user-sidebar>
                                <div class="col-9 col-sm-9 pta-content-center" v-if="is_loaded">
                                    <h4 class="card-title">Documents</h4>
                                  <ul class="pta-uploads">
                                    <li>
                                      <h3>Fact Sheet</h3>
                                      <a :href="'/fs2/'+id+'/pdf'" class="pta-ai-link">AI Generator</a>
                                      <file-upload-input :button-text="'Choose file to upload'" :token="upload_token" module="documents" :clear-file="clear_message_attachment" :module-id="1"></file-upload-input>
                                    </li>
                                    <li><h3>Presentation</h3>
                                      <a :href="'/ps2/'+id+'/pdf'" class="pta-ai-link">AI Generator</a>
                                      <file-upload-input :button-text="'Choose file to upload'" :token="upload_token" module="documents" :clear-file="clear_message_attachment" :module-id="2"></file-upload-input>
                                    </li>
                                    <li><h3>Team Bios</h3>
                                      <a :href="'/bios2/'+id+'/pdf'" class="pta-ai-link">AI Generator</a>
                                      <file-upload-input :button-text="'Choose file to upload'" :token="upload_token" module="documents" :clear-file="clear_message_attachment" :module-id="3"></file-upload-input>
                                    </li>
                                    <li><h3>Case Studies</h3>
                                      <a :href="'/cs/'+id+'/pdf'" class="pta-ai-link">AI Generator</a>
                                      <file-upload-input :button-text="'Choose file to upload'" :token="upload_token" module="documents" :clear-file="clear_message_attachment" :module-id="4"></file-upload-input>
                                    </li>
                                    <li><h3>FAQ/DDQ</h3>
                                      <a :href="'/faqs/'+id+'/pdf'" class="pta-ai-link">AI Generator</a>
                                      <file-upload-input :button-text="'Choose file to upload'" :token="upload_token" module="documents" :clear-file="clear_message_attachment" :module-id="5"></file-upload-input>
                                    </li>
                                    <li><h3>Track Record</h3>
                                      <a :href="'/tr/'+id+'/pdf'" class="pta-ai-link">AI Generator</a>
                                      <file-upload-input :button-text="'Choose file to upload'" :token="upload_token" module="documents" :clear-file="clear_message_attachment" :module-id="6"></file-upload-input>
                                    </li>
                                    <li><h3>Financial Model</h3>
                                      <file-upload-input :button-text="'Choose file to upload'" :token="upload_token" module="documents" :clear-file="clear_message_attachment" :module-id="7"></file-upload-input>
                                    </li>
                                    <li><h3>Key Terms</h3>
                                      <a :href="'/kt/'+id+'/pdf'" class="pta-ai-link">AI Generator</a>
                                      <file-upload-input :button-text="'Choose file to upload'" :token="upload_token" module="documents" :clear-file="clear_message_attachment" :module-id="8"></file-upload-input>
                                    </li>
                                    <li><h3>Market Reports</h3>
                                      <file-upload-input :button-text="'Choose file to upload'" :token="upload_token" module="documents" :clear-file="clear_message_attachment" :module-id="9"></file-upload-input>
                                    </li>
                                    <li><h3>Any other marketing materials</h3>
                                      <file-upload-input :button-text="'Choose file to upload'" :token="upload_token" module="documents" :clear-file="clear_message_attachment" :module-id="10"></file-upload-input>
                                    </li>
                                  </ul>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <user-summary :user="user"></user-summary>
            </div>
        </div>
    </div>
</template>

<script>
    import userSidebar from './general-partner-sidebar'
    import userSummary from './summary'
    import vSelect from 'vue-multiselect'
    import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
    import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
    import autosizeTextarea from '../../components/autosize-textarea'
    import {v4 as uuidv4} from "uuid";
    import fileUploadInput from '../../components/file-upload-input'

    export default {
        components : { userSidebar,userSummary,vSelect, VueCtkDateTimePicker, autosizeTextarea,fileUploadInput },
        data() {
            return {
              id:this.$route.params.id,
              countries_cur : '',
              countries_2_cur : '',
              fund_types_cur : '',
              fund_categories : '',
              fund_types : '',
              continents: '',
              countries: [],
              currencies: [],
              selected_hq_countries: [],
              // selected_iv_countries: [],
              selected_asset_countries: [],
              selected_main_countries: [],
              main_country_id: [],
              hq_country_id: [],
              iv_country_id: '',
              iv_country_id_temp: '',
              currency_id: '',
              currency_id_temp: '',
              asset_country_id: [],
              /* currency_id: [], */
              is_loading: false,
              upload_token: '',
              questionaireForm: new Form({
                company: '',
                phone: '',
                hq_country_id: [],
                investor_types: [],
                main_country_id: [],
                fund_category_id: '',
                fund_type_id: '',
                asset_country_id: [],
                iv_country_id: '',
                currency_id: '',
                holding_period: 0,
                esg: '',
                inv_struct: '',
                total_capital: '',
                irr: '',
                moic: '',
                ticket_size: '',
                strategy: '',
                fund_status: '',
                fund_first_time: '',
                fund_first_close: '',
                fund_final_close: '',
                track_record_1: '',
                track_record_2: '',
                track_record_3: '',
                track_record_4: '',
                step: 1,
                is_premium: 0
              },false),
              step: 1,
              is_premium: 0,
              is_send: false,
              questionnaire_step: 0,
              user: '',
              is_loaded: false,
              clear_message_attachment: false,
              userForm: new Form({
                phone: '',
                address_line_1: '',
                address_line_2: '',
                city: '',
                state: '',
                zipcode: '',
                country_id: ''
              },false),
            };
        },
        mounted(){
            if(!helper.hasPermission('edit-user')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

          axios.get('/api/user/'+this.id)
              .then(response => response.data)
              .then(response => {
                this.user = response.user;
                this.userForm.phone = response.user.profile.phone;
                this.userForm.address_line_1 = response.user.profile.address_line_1;
                this.userForm.address_line_2 = response.user.profile.address_line_2;
                this.userForm.city = response.user.profile.city;
                this.userForm.state = response.user.profile.state;
                this.userForm.zipcode = response.user.profile.zipcode;
                this.userForm.country_id = response.user.profile.country_id || '';

                this.upload_token = response.user.profile.upload_token;
                this.is_loaded = true;

              })
              .catch(error => {
                helper.showDataErrorMsg(error);
                this.$router.push('/user/general-partners');
              })

          this.prerequisite();

        },
        methods: {
          prerequisite(){
            axios.get('/api/user/profile/questionnaire/pre-requisite')
                .then(response => response.data)
                .then(response => {
                  this.fund_categories  = response.fund_categories;
                  this.fund_types       = response.fund_types;
                  this.continents       = response.continents;
                  this.countries        = response.countries;
                  this.currencies        = response.currencies;
                  this.getQuestionnaire();
                })
                .catch(error => {
                  helper.showDataErrorMsg(error)
                });
          },
          onMainCountrySelect(selectedOption){
            this.questionaireForm.errors.clear('main_country_id');
            this.main_country_id.push(selectedOption.id);
          },
          onMainCountryRemove(removedOption){
            this.main_country_id.splice(this.main_country_id.indexOf(removedOption.id), 1);
          },
          onHQCountrySelect(selectedOption){
            this.questionaireForm.errors.clear('hq_country_id');
            this.hq_country_id.push(selectedOption.id);
          },
          onHQCountryRemove(removedOption){
            this.hq_country_id.splice(this.hq_country_id.indexOf(removedOption.id), 1);
          },
          onAssetCountrySelect(selectedOption){
            this.questionaireForm.errors.clear('asset_country_id');
            this.asset_country_id.push(selectedOption.id);
          },
          onAssetCountryRemove(removedOption){
            this.asset_country_id.splice(this.asset_country_id.indexOf(removedOption.id), 1);
          },

          goNext(){
            if(!this.is_send) {
              this.is_send = true;
              this.selected_hq_countries.forEach(function (item) {
                this.questionaireForm.hq_country_id.push(item.id);
              }.bind(this));

              this.selected_main_countries.forEach(function (item) {
                this.questionaireForm.main_country_id.push(item.id);
              }.bind(this));

              this.selected_asset_countries.forEach(function (item) {
                this.questionaireForm.asset_country_id.push(item.id);
              }.bind(this));

              this.questionaireForm.currency_id = this.currency_id.id;
              this.questionaireForm.iv_country_id = this.iv_country_id.id;
              this.questionaireForm.step = this.step;
              this.questionaireForm.is_premium = this.is_premium;
              this.questionaireForm.post('/api/user/profile/questionnaire')
                  .then(response => {
                    toastr.success(response.message);
                    this.step = this.step + 1;
                    this.questionaireForm.hq_country_id = [];
                    this.questionaireForm.main_country_id = [];
                    this.questionaireForm.asset_country_id = [];
                    this.questionaireForm.iv_country_id = '';
                    this.questionaireForm.currency_id = '';
                    this.is_send = false;
                    this.questionnaire_step = response.questionnaire_step;
                  })
                  .catch(error => {
                    helper.showErrorMsg(error);
                    this.is_send = false;
                  });

            }
          },
          getFundTypes(){
            this.questionaireForm.fund_type_id = '';
            if(this.questionaireForm.fund_category_id){
              this.fund_categories.forEach(function(fund_category) {
                if(fund_category.id==this.questionaireForm.fund_category_id){
                  this.fund_types_cur = fund_category.fund_types;
                }
              }.bind(this));
            }
          },
          getQuestionnaire(){
            axios.get('/api/user/'+this.id+'/questionnaire')
                .then(response => response.data)
                .then(response => {
                  if(response.user.profile.hq_countries){
                    this.selected_hq_countries       = response.user.profile.hq_countries;
                  }else{
                    this.selected_hq_countries    = [];
                  }
                  if(response.user.profile.main_countries){
                    this.selected_main_countries    = response.user.profile.main_countries;
                  }else{
                    this.selected_main_countries    = [];
                  }

                  if(response.user.profile.asset_countries){
                    this.selected_asset_countries    = response.user.profile.asset_countries;
                  }else{
                    this.selected_asset_countries     = [];
                  }

                  if(response.user.profile.fund_category_id){
                    this.questionaireForm.fund_category_id  = response.user.profile.fund_category_id;
                    this.getFundTypes();
                  }else{
                    this.questionaireForm.fund_category_id     = '';
                  }

                  if(response.user.profile.fund_type_id){
                    this.questionaireForm.fund_type_id = response.user.profile.fund_type_id;
                  }else{
                    this.questionaireForm.fund_type_id = '';
                  }

                  this.questionaireForm.investor_types      = response.user.profile.investor_types;
                  if(response.user.profile.company == '') {
                    this.questionaireForm.investor_types = [];
                  }

                  if(response.user.profile.currency_id){
                    this.currency_id_temp = response.user.profile.currency_id;
                    this.currencies.forEach(function (item) {
                      if(this.currency_id_temp == item.id){
                        this.currency_id = item;
                        return;
                      }
                    }.bind(this));
                  }

                  if(response.user.profile.iv_country_id){
                    this.iv_country_id_temp = response.user.profile.iv_country_id;
                    this.countries.forEach(function (item) {
                      if(this.iv_country_id_temp == item.id){
                        this.iv_country_id = item;
                        return;
                      }
                    }.bind(this));
                  }

                  this.questionnaire_step =  response.user.profile.questionnaire_step;
                  this.questionaireForm.company             = response.user.profile.company;
                  this.questionaireForm.phone               = response.user.profile.phone;
                  this.questionaireForm.holding_period               = response.user.profile.holding_period;
                  this.questionaireForm.esg                   = response.user.profile.esg;
                  this.questionaireForm.inv_struct               = response.user.profile.inv_struct;
                  this.questionaireForm.total_capital               = response.user.profile.total_capital;
                  this.questionaireForm.irr                         = response.user.profile.irr;
                  this.questionaireForm.moic                        = response.user.profile.moic;
                  this.questionaireForm.ticket_size                 = response.user.profile.ticket_size;
                  this.questionaireForm.strategy                    = response.user.profile.strategy;
                  this.questionaireForm.fund_status                 = response.user.profile.fund_status;
                  this.questionaireForm.fund_first_time             = response.user.profile.fund_first_time;
                  this.questionaireForm.fund_first_close            = response.user.profile.fund_first_close;
                  this.questionaireForm.fund_final_close            = response.user.profile.fund_final_close;
                  this.questionaireForm.track_record_1              = response.user.profile.track_record_1;
                  this.questionaireForm.track_record_2    = response.user.profile.track_record_2;
                  this.questionaireForm.track_record_3    = response.user.profile.track_record_3;
                  this.questionaireForm.track_record_4    = response.user.profile.track_record_4;

                  this.is_premium = response.user.profile.is_premium;
                  this.is_loading = false;
                })
                .catch(error => {
                  helper.showDataErrorMsg(error)
                });
          },
          onlyAmount ($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode != 46 ) {
              $event.preventDefault();
            }
          },
        }
    }
</script>
<style>
.pta-content-documents .btn-danger,
.pta-content-documents button{
  display:none;
}
.pta-content-document{
  padding:20px;
  border:1px solid #6278A1;
}
</style>
